
import * as React from "react";
import * as ReactDOM from "react-dom";
import 'jquery';
import 'bootstrap';
import 'bootstrap-datepicker';
import '../../css/bootstrap.css';
import '../../../htdocs/css/signature.css';
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import { Loader } from "../lib/Loader";
import SignaturePad from "./SignaturePad";

interface ISetInit{

    (state:IMomoFormState):IMomoFormState
}
interface IbeforeSubmit{
    (fields:Array<IField>, sendData:any, setState:Function):boolean
}
interface IafterSubmit{
    (sendData:any, resultCb:Function):void
}
interface Ichanged{
    (fields:any):void
}

interface IMomoFormProps {
    momoKey                 : string
    lang                    : string
    externalCss             : string
    autoSendEnabled         : Boolean
    sendManualFunctionName  : string
    checkboxStyleSetNative  : boolean
    setInit                 : ISetInit
    formRendered            : Function
    beforeSubmit            : IbeforeSubmit
    afterSubmit             : IafterSubmit
    changed                 : Ichanged
    setFieldsFunctionName   : string
    customSendBtnLabel      : string
}
interface IOption {
    value:string
    label:string
}

export interface IField{
    name          : string
    type          : string
    id            : string
    className     : string
    value         : string|Array<string>
    labelRawHTML  : string
    placeholder   : string
    hidden        : boolean
    checked       : boolean
    selectOptions : Array<IOption>
    required      : boolean
    readOnly       : boolean
    for           : string
}

interface IMomoFormState {
    fields            : Array<IField>
    title             : string
    picture           : string
    form_comment      : string
    redirectUrl       : string
    successText       : string
    url               : string

    success           : string
    error             : string
    loading           : boolean
    sendBtnLabel      : string
}

export default class MomoForm extends React.Component<IMomoFormProps, IMomoFormState>{

    private serverUrl:string;
    private eventProcessing: boolean;
    private sendData: any;

    constructor(props:IMomoFormProps){
        super(props);
        this.serverUrl = 'https://app.momocrm.hu/form/';
        if ( window.location.href.indexOf('.localhost:88') > -1 ) {
            this.serverUrl = '//momo.localhost:88/form/';
        }else if ( window.location.href.indexOf('.localhost') > -1 ) {
            this.serverUrl = '//momo.localhost/form/';
        }else if ( window.location.href.indexOf('.local') > -1 ) {
            this.serverUrl = '//momo.local/form/';
        }

        if ( window.location.href.indexOf('leier.momo-server2.com') > -1 ) {
            this.serverUrl = 'https://leier.momo-server2.com/form/';
        }else if ( window.location.href.indexOf('.momo-server2.com') > -1 ) {
            this.serverUrl = 'https://app.momo-server2.com/form/';
        }

        if ( this.props.externalCss !== null && this.props.externalCss !== '' ) {
            Loader.loadCss(this.props.externalCss);
        }

        this.eventProcessing = false;
        this.state = {
            title      : '',
            picture    : '',
            form_comment      : '',
            fields     : [],
            redirectUrl: '',
            successText: '',
            url        : '',
            success    : null,
            error      : null,
            loading    : true,
            sendBtnLabel: this.props.customSendBtnLabel!==null?this.props.customSendBtnLabel:(this.props.lang==='hu'?'Küldés':'Send')
        };
        if ( this.props.sendManualFunctionName !== null) {
            (window as any)[this.props.sendManualFunctionName] = () => {
                console.log('Please call this, after form loaded!');
            };
        }
        if ( this.props.setFieldsFunctionName !== null) {
            (window as any)[this.props.setFieldsFunctionName] = (newFields:any) => {
                var fields = this.state.fields;
                for (var key in newFields) {
                    fields = this.setField(fields, key, newFields[key]);
                }
                this.setState({
                    fields: fields
                });

            };
        }
        this.getConfig();
    }

    private setField(fields:Array<IField>, name:String, newValues:any):Array<IField>{
        for (var key in fields) {
            var item = fields[key];
            if ( item.name === name ) {
                item = Object.assign(item, newValues);
            }
        }
        return fields;
    }

    private getConfig():void{
        if ( this.props.momoKey !== '' ) {
            fetch(this.serverUrl+this.props.momoKey+'?jsonMode=1')
            .then((response) => {
                return response.json();
            })
            .then((myJson) => {
                this.setState({
                    fields     : this.formatFields(myJson.fields),
                    redirectUrl: myJson.redirectUrl,
                    successText: myJson.successText,
                    url        : myJson.url,
                    title      : myJson.title,
                    picture    : myJson.picture,
                    form_comment : myJson.form_comment,
                    loading    : false
                }, ()=>{
                    if ( this.props.setInit !== null ) {
                        var newState     = this.props.setInit(this.state);
                        newState.fields  = this.fixFields(newState.fields);
                        this.setState(newState, () => {
                            this.configLoaded();
                        });
                    }else{
                        this.configLoaded();
                    }
                });
            });
        }else{
            setTimeout(() => {
                this.setState({
                    loading    : false
                }, ()=>{
                    if ( this.props.setInit !== null ) {
                        var newState     = this.props.setInit(this.state);
                        newState.fields  = this.fixFields(newState.fields);
                        this.setState(newState, () => {
                            this.configLoaded();
                        });
                    }else{
                        this.configLoaded();
                    }
                });
            }, 100)
        }
    }

    private formatFields(fields):Array<IField>{
        if ( this.props.checkboxStyleSetNative === false ) {
            for (var key in fields) {
                var item = fields[key];
                if ( item.type === "checkbox" ) {
                    item.type = "checkbox_from_momo"
                }
            }
        }
        return fields;
    }

    private fixFields(fields):Array<IField>{
        for (var key in fields) {
            var item = fields[key];
            if( item.id === undefined ) {
                item.id = '';
            }
            if( item.className === undefined ) {
                item.className = '';
            }
            if( item.placeholder === undefined ) {
                item.placeholder = '';
            }
            if( item.hidden === undefined ) {
                item.hidden = false;
            }
            if( item.checked === undefined ) {
                item.checked = false;
            }
            if( item.selectOptions === undefined ) {
                item.selectOptions = [];
            }
            if( item.selectOptions === undefined ) {
                item.selectOptions = null;
            }
            if( item.required === undefined ) {
                item.required = false;
            }
            if( item.readOnly === undefined ) {
                item.readOnly = false;
            }
            if( item.for === undefined ) {
                item.for = '';
            }

        }
        return fields;
    }

    private configLoaded() {
        if (this.props.autoSendEnabled === true) {
            this.onSubmitHandler();
        }
        if ( this.props.sendManualFunctionName !== null) {
            (window as any)[this.props.sendManualFunctionName] = () => {
                this.onSubmitHandler();
            };
        }
    }

    private onSubmitHandler(evt=undefined): void {
        if ( evt !== undefined ) {
            evt.preventDefault();
        }
        this.setState({
            loading: true
        }, () =>{
            var sendData = this.getSendData();
            if ( this.props.beforeSubmit !== null ) {
                if ( this.props.beforeSubmit(this.state.fields, this.sendData, (state:IMomoFormState) =>{
                    this.setState(state);
                }) === false ) {
                    return;
                }
            }
            if ( this.state.url === '' ) {
                console.log('url is empty -> save blocked');
                return;
            }
            this.postData(this.state.url+'?jsonMode=1', sendData)
            .then( data => {
                if ( data.success !== undefined ) {
                    if ( this.props.afterSubmit !== null ) {
                        this.props.afterSubmit(this.sendData, ()=>{
                            this.successSaveMethod();
                        })
                    }else{
                        this.successSaveMethod();
                    }
                }else{
                    this.setState({
                        error  : data.error,
                        success: null,
                        loading: false
                    });
                }
            })
            .catch(error => console.error(error));
        });
    }

    private successSaveMethod() {
        if (this.state.redirectUrl !== '') {
            window.location.href = this.state.redirectUrl;
        }
        else {
            this.setState({
                success: this.state.successText,
                error: null,
                loading: false
            });
        }
    }

    private postData(url:string, data) {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                //'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow',
            referrer: 'no-referrer',
            body: data,
        })
        .then(response => response.json());
    }

    private getSendData():any{
        var json:any = {};
        var fielsId = {};
        for (var key in this.state.fields) {
            let item = this.state.fields[key];
            if ( item.type === 'label' ) {
                continue;
            }
            if ( item.type === 'file' ) { //only one
                json[item.name]    = null;
                fielsId[item.name] = item.id;
                continue;
            }
            if ( json[item.name] !== undefined ) {
                if ( typeof json[item.name] !== 'object' ) {
                    json[item.name] = [json[item.name]];
                }
                if ( item.type.indexOf('checkbox') > -1 ) {
                    if ( item.checked === true ) {
                        json[item.name].push(item.value);
                    }
                }else{
                    json[item.name].push(item.value);
                }
            }else{
                if ( item.type.indexOf('checkbox') > -1 ) {
                    if ( item.checked === true ) {
                        json[item.name] = item.value;
                    }
                }else{
                    json[item.name] = item.value;
                }
            }
        }
        this.sendData = json;
        var formData = new FormData();
        for (var key in json) {
            let item = json[key];
            if ( typeof item === 'object' && item !== null ) {
                for (var iitem of item) {
                    formData.append(key+'[]', iitem);
                }
            }else{
                if ( item === null) { //when file
                    let element = (document.getElementById(fielsId[key]) as any);
                    if ( element !== null ) {
                        if ( element.files !== undefined &&  element.files !== null ) {
                            var files = element.files;
                            if ( files[0] !== undefined ) {
                                for (var fkey in files) {
                                    if ( files[fkey] !== '' && files[fkey].toString().length > 10 ) {
                                        formData.append(key+'[]', files[fkey]);
                                    }
                                }
                            }
                        }
                    }
                }else{
                    formData.append(key, item);
                }
            }
        }
        return formData;
    }

    private changeInputHandler(evt, id:string, value:string=null): void {
        if ( evt != undefined) {
            evt.preventDefault();
        }
        var fields          = this.state.fields;
        let founded:boolean =  false;
        for (var key in fields) {
            var item = fields[key];
            console.log(item);
            if ( item.id === id ) {
                if ( item.type.indexOf('checkbox') > -1  ) {
                    item.checked = !item.checked;
                }else{
                    if ( value !== null ) {
                        item.value = value;
                    }else{
                        item.value = evt.target.value;
                    }
                }
                founded = true;
                break;
            }
        }
        if (founded === false ) {
            for (var key in fields) {
                var item = fields[key];
                if ('file_' + item.id === id) {
                    let newBase64ImageItem:IField   = JSON.parse(JSON.stringify(item));
                    newBase64ImageItem.hidden = true;
                    newBase64ImageItem.type  = 'text';
                    newBase64ImageItem.id    = id;
                    newBase64ImageItem.name  = 'file_' + item.name;
                    newBase64ImageItem.value = value;
                    fields.push(newBase64ImageItem);
                    break;
                }
            }
        }
        this.setState({
            fields: fields
        }, () =>{
            if ( this.props.changed !== null ) {
                this.props.changed(this.jsonFields());
            }
        });
    }

    private jsonFields(): any {
        var json = {};
        for (var key in this.state.fields) {
            var item = this.state.fields[key];
            if ( json[item.name] !== undefined ) {
                if ( typeof json[item.name] !== 'object' ) {
                    json[item.name] = [json[item.name]];
                }
                json[item.name].push(item);
            }else{
                json[item.name] = item;
            }
        }
        return json;
    }



    render() {
        this.events();

        return (
            <div className="momo_form">
                {
                    this.state.success!==null?
                        <div className="alert alert-success" role="alert"><span>{this.state.success}</span></div>
                    :
                    <form onSubmit={ e => this.onSubmitHandler(e) }>
                    { this.state.picture!==''?<img src={ this.state.picture } style={{ margin: '10px auto',display: 'block' }} />:''}
                    { this.state.title!==''?<h1 style={{ textAlign: 'center' }}>{ this.state.title }</h1>:''}
                    { this.state.form_comment!==''?<div className="form-group" style={{ textAlign: 'center' }}>{ this.state.form_comment }</div>:''}

                {
                    this.state.fields.map((item, key)=>{
                        if ( item.hidden === true ) {
                            return;
                        }
                        if( item.readOnly === undefined ) {
                            item.readOnly = false;

                        }
                        var htmlElement = null;
                        var label = item.labelRawHTML;
                        switch (item.type) {
                            case 'textarea':
                                    htmlElement = <div className="mb-3">
                                        <label htmlFor={ item.id }>
                                            <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                        </label>
                                        <textarea
                                            rows={8}
                                            cols={30}
                                            value={ item.value }
                                            id={ item.id }
                                            className={'form-control ' + item.className}
                                            placeholder={ item.placeholder }
                                            required={ item.required }
                                            readOnly={ item.readOnly }
                                            onChange={ (e) => this.changeInputHandler(e, item.id) }
                                        />
                                    </div>
                                break;
                            case 'file':
                                    htmlElement = <div className="mb-3">
                                        <label htmlFor={ item.id }>
                                            <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                        </label>
                                        <SignaturePad item={item} key={'signature_' + item.id} onChange={(id:string, value:string) => {
                                                    this.changeInputHandler(undefined, id, value);
                                                }
                                            } />
                                    </div>;
                                break;
                            case 'select':
                                    htmlElement = <div className="mb-3">
                                        <label htmlFor={ item.id }>
                                            <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                        </label>
                                        <select
                                            defaultValue={ item.value }
                                            id={ item.id }
                                            className={'form-control ' + item.className}
                                            placeholder={ item.placeholder }
                                            required={ item.required }
                                            disabled={ item.readOnly }
                                            onChange={ (e) => this.changeInputHandler(e, item.id) }
                                            >
                                            { item.selectOptions.map((item:IOption, key:number) => {
                                                return <option key={key} value={item.value}>
                                                    { item.label }
                                                </option>
                                            })}
                                        </select>
                                    </div>
                                break;
                            case 'label':
                                htmlElement = <div id={ item.id } className={ item.className } >
                                        <label htmlFor={ item.for }>
                                            <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                        </label>
                                </div>;
                                break;
                            case 'checkbox_from_momo':
                                    var lastSimilarItem = false;
                                    if ( this.state.fields[key+1] !== undefined ) {
                                        // check next items
                                        if( this.state.fields[key+1].name !== item.name ) {
                                            lastSimilarItem = true;
                                        }
                                    }else{
                                        lastSimilarItem = true;
                                    }
                                    htmlElement = <>
                                        <div className="form-check form-control" style={{
                                            display: 'inline-block',
                                            width: 'auto',
                                            paddingLeft: '10px',
                                            paddingRight: '30px',
                                            marginRight: '20px'
                                        }}>
                                            <label htmlFor={ item.id } style={{

                                            }}>
                                                <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                            </label>
                                            <input
                                                data-type="checkbox_from_momo"
                                                type="checkbox"
                                                name={item.name}
                                                data-required_checkbox={item.required}
                                                value={item.value}
                                                key={ item.id+'_'+item.checked.toString() }
                                                id={ item.id }
                                                className={'form-check-input ' + item.className}
                                                disabled={ item.readOnly }
                                                checked={item.checked}
                                                onChange={ (e) => this.changeInputHandler(e, item.id) }
                                                style={{
                                                    marginLeft: '5px'
                                                }}
                                            />

                                        </div>
                                        {lastSimilarItem===true?<div className="mb-3"></div>:''}
                                    </>
                                break;
                            case 'checkbox':
                                    var lastSimilarItem = false;
                                    if ( this.state.fields[key+1] !== undefined ) {
                                        // check next items
                                        if( this.state.fields[key+1].name !== item.name ) {
                                            lastSimilarItem = true;
                                        }
                                    }else{
                                        lastSimilarItem = true;
                                    }
                                    htmlElement = <>
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                value={item.value}
                                                key={ item.id+'_'+item.checked.toString() }
                                                id={ item.id }
                                                className={'form-check-input ' + item.className}
                                                required={ item.required }
                                                disabled={ item.readOnly }
                                                checked={item.checked}
                                                onChange={ (e) => this.changeInputHandler(e, item.id) }
                                            />
                                            <label htmlFor={ item.id }>
                                                <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                            </label>
                                        </div>
                                        {lastSimilarItem===true?<div className="mb-3"></div>:''}
                                    </>
                                break;

                            default:
                                htmlElement = <div className="mb-3">
                                    <label htmlFor={ item.id }>
                                        <strong dangerouslySetInnerHTML={ {__html: label } }></strong>
                                    </label>
                                    <input
                                        type={ item.type }
                                        value={ item.value }
                                        id={ item.id }
                                        className={ 'form-control ' + item.className}
                                        placeholder={ item.placeholder }
                                        required={ item.required }
                                        readOnly={ item.readOnly }
                                        onChange={ (e) => this.changeInputHandler(e, item.id) }
                                    />
                                </div>;
                                break;
                        }
                        return <span key={key}>
                            { htmlElement }
                        </span>;
                    })
                }
                    {
                        this.state.error!==null?<div role="alert" className="alert alert-danger"><span>{this.state.error}</span></div>:''
                    }
                    { this.state.loading === true?<button type="submit" className="btn btn-success" disabled={true}>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>:<button type="submit" className="btn btn-success">{this.state.sendBtnLabel}</button> }
                </form>
                }
			</div>
        );
    }
    private events():void {
        if ( this.eventProcessing === false ) {
            this.eventProcessing = true;
            setTimeout(()=>{
                ($('[type=date]') as any).datepicker(
                    {
                        format: 'yyyy.mm.dd.',
                        language: 'hu',
                        todayHighlight: true,
                        container:'.momo_form'
                    }
                ).off('changeDate').on('changeDate', (e) => {
                    var id      = e.target.id;
                    var newDate = $('#'+id).val().toString();
                    //newDate = newDate.replace(/\./g, '-')external_css.substr(0,newDate.replace(/\./g, '-').length-1);
                    this.changeInputHandler(undefined, id, newDate)
                }).attr('type', 'text');

                $('input[data-required_checkbox="true"]').each((i, ele) => {
                    this.requiredCheckbox($(ele).attr('name'));
                });
                $('input[data-required_checkbox="true"]').change((ele) => {
                    this.requiredCheckbox($(ele).attr('name'));
                });


                if ( this.props.formRendered !== null) {
                    this.props.formRendered();
                }
                this.eventProcessing = false;
            }, 800);
        }
    }

    private  requiredCheckbox(name) {
        console.log(name);
        var emptyInput = $('input[name="' + name + '"][data-required_checkbox="true"]:checked').length === 0;
        if (emptyInput === true) {
            $('input[name="' + name + '"][data-required_checkbox="true"]:first').attr('required', 'true');
        } else {
            $('input[name="' + name + '"][data-required_checkbox="true"]').removeAttr('required');
        }
    }
}
export class InitMomoForm {
    constructor() {
        var divs:any = document.querySelectorAll('.momo_form_comp');
        for (var key in divs) {
            var item = divs[key];
            if ( item.dataset !== undefined) {
                var data:any         = item.dataset;

                var setInit:ISetInit = null;
                if ( (window as any)[data.init] !== undefined ) {
                    setInit = (window as any)[data.init];
                }

                var formRendered:Function = null;
                if ( (window as any)[data.form_rendered] !== undefined ) {
                    formRendered = (window as any)[data.form_rendered];
                }

                var beforeSubmit:IbeforeSubmit = null;
                if ( (window as any)[data.before_submit] !== undefined ) {
                    beforeSubmit = (window as any)[data.before_submit];
                }
                var afterSubmit:IafterSubmit = null;
                if ( (window as any)[data.after_submit] !== undefined ) {
                    afterSubmit = (window as any)[data.after_submit];
                }
                var changed:Ichanged = null;
                if ( (window as any)[data.changed] !== undefined ) {
                    changed = (window as any)[data.changed];
                }

                ReactDOM.render(<MomoForm
                    momoKey={ data.momo_key }
                    lang={ data.lang!==undefined?data.lang:'hu' }
                    externalCss={ data.external_css!==undefined?data.external_css:null }
                    autoSendEnabled={ data.auto_send_enabled==='true'?true:false }
                    customSendBtnLabel={ data.custom_send_btn_label!==undefined?data.custom_send_btn_label:null}
                    sendManualFunctionName={ data.send_manual_function_name!==undefined?data.send_manual_function_name:null }
                    setFieldsFunctionName={ data.set_fields_function_name!==undefined?data.set_fields_function_name:null }
                    setInit={ setInit }
                    beforeSubmit={ beforeSubmit }
                    afterSubmit={ afterSubmit }
                    formRendered={ formRendered }
                    changed={ changed }
                    checkboxStyleSetNative={ data.set_native_checkbox_style!==undefined?(data.set_native_checkbox_style==='true'?true:false):false }
                />, item);
            }
        }
    }
}

